import { lazy, Suspense } from 'react';

import { SidePanelBody } from '@/shared/components/side-panel';
import { CardSkeleton } from '@/shared/components/skeletons';

/*
 * Entry points registered by `index.ts` load their code on demand: the module index is imported eagerly by the shell,
 * and the editor, comments and cards must not weigh on the first page load of other modules.
 */

const PostPanel = lazy(async () => ({ default: (await import('./components/PostPanel')).PostPanel }));
const GroupFeedTab = lazy(async () => ({
  default: (await import('./components/GroupFeedTab')).GroupFeedTab,
}));

export function LazyPostPanel({ id }: { id: string }) {
  return (
    <Suspense
      fallback={
        <SidePanelBody>
          <CardSkeleton />
        </SidePanelBody>
      }
    >
      <PostPanel id={id} />
    </Suspense>
  );
}

export function LazyGroupFeedTab({ groupId }: { groupId: string }) {
  return (
    <Suspense fallback={<CardSkeleton />}>
      <GroupFeedTab groupId={groupId} />
    </Suspense>
  );
}
